module.exports = __webpack_public_path__ + "static/advanced-security-recommendation-cb132b22bfe41ec73c7c126c22d8cbd3.svg";